import store from "@/store"
import { lazy }from 'react';

import {
    ConvertResultMessage,
    NotificationMessage,
    ToDoMessageDialog2,
    ToDoMessageTemplatePlugin,
    MessageDialogStore,
    ScannedEditingSetting,
    PwaTipsDlg,
    // ShareDlg,
    FwShareDlg,
    CollaborationSignIn,
} from '../dialogs/index';

const FoxitSignRemind = lazy(() => import('@/components/FoxitSign/Remind/FoxitSignRemind'));
const FoxitSignIntro = lazy(() => import('@/components/FoxitSign/Intro/FoxitSignIntro'));
const MultiTabsBar=lazy(()=>import('Components/MultiTabsBar/MultiTabsBar'));
const ESignCNSurvey=lazy(()=>import('Components/EsignChina/eSignCNSurvey'));

const dialogBuilder = (uiMgr) => {
    const { taskMessage } = store.taskStore;
    if (taskMessage) {
        return {
            target: ConvertResultMessage,
            config: {
                msg: taskMessage,
                onDownloadSuccess: () => {}
            }
        }
    }

    const { MessageStore, Ai_openFile, notificationMessageArr, ScannedDocumentSetting, Template_openFile, isShowPwaTips } = store.appStore;
    if (notificationMessageArr.length > 0) {
        return {
            target: NotificationMessage,
        }
    }


    if (Ai_openFile.isShow) {
        return {
            target: ToDoMessageDialog2,
            config: {
                visible: true,
            }
        }
    }


    if (Template_openFile.isShow) {
        return {
            target: ToDoMessageTemplatePlugin,
            config: {
                visible: true,
            }
        }
    }


    if (MessageStore.isShow) {
        return {
            target: MessageDialogStore,
            config: {
                visible: true,
            }
        }
    }

    if (ScannedDocumentSetting.visible)
        return {
            target: ScannedEditingSetting,
            config: {
                visible: true,
            }
        }

    if (isShowPwaTips)
        return {
            target: PwaTipsDlg,
        }

    const { hasSignIn, roleInfo } = store.userStore;
    const { isShowShareDialog, isShowCollaborationSignIn } = store.collaborationStore;
    if (isShowShareDialog) {
        return {
            target: FwShareDlg,
            config: {
                visible: true
            }
        }
    }


    if (!hasSignIn && isShowCollaborationSignIn)
        return {
            target: CollaborationSignIn

        }


    const { foxitSignVisibleModal, foxitSignRemindDetail } = store.foxitSignStore;

    if (foxitSignVisibleModal === 'Remind')
        return {
            target: FoxitSignRemind,
            config: {
                onCancel: uiMgr.onCancelFoxitSign,
                detail: foxitSignRemindDetail,
                isEnterprise: roleInfo
            }
        }
    if (foxitSignVisibleModal === 'Intro')
        return {
            target: FoxitSignIntro,
            config: {
                onCancel: uiMgr.onCancelFoxitSign
            }
        }
    let { isMultiTabsBarInit } = store.viewer;

    if (isMultiTabsBarInit) return {
        target: MultiTabsBar
    }

    if(store.esignCnStore.surveyVisible)
    return {
        target:ESignCNSurvey,
        config:{
            visible:true,
            handleCloseSurvey:()=>{store.esignCnStore.updateESignCNSurveyVisible(false)}
        }
    }
    
    return {}
}


export default dialogBuilder